import { AssetEvent } from './asset.event';
import { EventRegistry } from '../../../../../domain/event/event.registry';
export class AssetUnarchivedEvent extends AssetEvent {
    constructor(payload, metadata, fromPersistence) {
        super({
            subject: `asset-class/${payload.assetClassId}/asset/${payload.id}`,
            type: AssetUnarchivedEvent.type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
AssetUnarchivedEvent.type = 'com.treeplotter.api.asset.unarchived.v1';
EventRegistry.register(AssetUnarchivedEvent.type, AssetUnarchivedEvent);
//# sourceMappingURL=asset-unarchived.event.js.map